module.exports = __webpack_public_path__ + "static/media/select.b56bcd33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/select.svg
// module id = 479
// module chunks = 7